
const Lang: any = {
  ko: {
    // Buttons
    btn_signup: '회원가입',
    btn_login: '로그인',
    btn_logout: '로그아웃',
    btn_confirm: '확인',
    btn_cancel: '취소',
    btn_register: '등록',
    btn_close: '닫기',
    btn_write: '글쓰기',
    btn_modify: '수정',
    btn_delete: '삭제',
    btn_bookmark_delete: '해제',
    btn_list: '글목록',
    btn_more: '더보기',
    btn_refresh: '새로고침',
    btn_prev: '이전',
    btn_next: '다음',
    btn_declare: '신고',
    btn_write_reply: '덧글쓰기',
    btn_attach_emoticon: '이모티콘 첨부',
    btn_attach_img: '이미지 첨부',
    btn_send: '전송',
    btn_realname: '실명 인증',
    btn_reporting: '신고/이의 내역',
    btn_fromlist: '목록으로',
    btn_yes: '예',
    btn_no: '아니오',
    btn_search: '찾기',
    btn_reset: '초기화',
    btn_finish: '완료',
    btn_orderby_desc: '최신순',
    btn_orderby_good: '추천순',
    btn_orderby_asc: '과거순',

    // SNS
    kakao: '카카오톡',
    kakaostory: '카카오스토리',
    facebook: '페이스북',
    twitter: '트위터',

    // Icons
    icon_attach: '이미지 첨부',
    icon_new: '새글',
    icon_type_list: '리스트 타입',
    icon_type_card: '카드 타입',
    icon_guide: '안내',

    // Words
    title: '제목',
    notice: '공지',
    share: '공유하기',
    recommend: '추천',
    write: '글쓰기',
    search: '검색',
    hit: '조회',
    comment: '댓글',
    administrator: '관리자',
    level: '레벨',
    count: '개',
    emoticon: '이모티콘',
    choose: '분류',

    // List
    list_msg_delete: '삭제된 게시글 입니다.',
    list_none_article: '등록된 글이 없습니다.',
    list_none_point: '포인트 기록이 없습니다.',

    // Search form
    search_none: '검색 결과가 없습니다. ',
    search_searchtype_content: '제목+내용',
    search_searchtype_title: '제목',
    search_searchtype_writer: '작성자',
    search_result: '검색결과',
    search_result_count: '건',
    search_result_return: '돌아가기',
    search_place_holder: '게시글 검색',

    // View
    prev_article: '이전글',
    next_article: '다음글',
    more_bookmark: '북마크',
    more_modify: '수정',
    more_delete: '삭제',
    more_report: '신고',
    signature_friend: '친구',
    signature_another_article: '작성글',

    // Comment
    comment_title: '댓글',
    comment_placeholder_logout: '로그인 후 댓글을 입력하실 수 있습니다.',
    comment_placeholder_login: '댓글은 300자까지 작성 가능합니다.',
    comment_placeholder_login_max: ( max = '300' ) => `댓글은 ${ max }자까지 작성 가능합니다.`,
    comment_placeholder_image: '댓글을 입력하세요. 이미지는 선택 시 바로 등록됩니다.',
    comment_placeholder_emoticon: '댓글을 입력하세요. 이모티콘, 이미지는 선택 시 바로 등록됩니다.',
    comment_list_delete: '삭제된 댓글 입니다.',
    comment_reply_placeholder_logout: '로그인 후 덧글을 입력하실 수 있습니다.',
    comment_reply_placeholder_login: '덧글을 입력하세요.',
    comment_reply_placeholder_image: '덧글을 입력하세요. 이미지는 선택 시 바로 등록됩니다.',
    comment_reply_placeholder_emoticon: '덧글을 입력하세요. 이모티콘, 이미지는 선택 시 바로 등록됩니다.',
    comment_reply_list_delete: '삭제된 덧글 입니다.',
    comment_placeholder_empty: '첫 댓글을 남겨주세요.',
    comment_none_article: '첫 댓글을 남겨주세요.',
    comment_chat_placeholder: '혈맹원들과 대화를 나눠보세요.',
    comment_image_upload: '업로드 중입니다.',

    // Write
    write_placeholder_title: '제목',
    write_placeholder_textarea: '내용',
    write_placeholder_contents: '내용',
    write_attention: '욕설, 도배, 비방, 루머등 운영정책에 어긋나는 게시물 등록 시에는 글쓰기 제한 등 불이익을 받으실 수 있습니다.',

    // editor
    editor_font_face: '글꼴',
    editor_font_size: '크기',
    editor_font_color: '글자색',
    editor_bg_color: '배경색',
    editor_strong: '굵게',
    editor_underline: '밑줄',
    editor_strike: '취소선',
    editor_justify_left: '왼쪽 정렬',
    editor_justify_center: '가운데 정렬',
    editor_justify_right: '오른쪽 정렬',
    editor_link: '링크',
    editor_remove_link: '링크 지우기',
    editor_unordered_list: '글머리 기호',
    editor_ordered_list: '번호 매기기',
    editor_insert_image: '이미지 첨부',
    editor_insert_youtube: '유투브 첨부',
    editor_upload_movie: '동영상',

    // alert
    alert_valid_upload: '현재 진행 중인 작업이 있습니다.\n잠시만 기다려 주세요.',
    alert_delete_article: '삭제 하시겠습니까?',
    alert_cancel_article: '글쓰기를 취소하시겠습니까?',
    alert_empty_title: '제목을 입력해 주세요. ',
    alert_too_short_title: '제목은 2자 이상 입력해 주세요.',
    alert_too_long_title: '제목을 50자 이내로 입력해 주세요.  ',
    alert_empty_contents: '내용을 입력하세요.',
    alert_progressing: '요청 중 입니다. 잠시만 기다려 주세요.',
    alert_empty_images: '이미지를 올려주세요.',
    alert_empty_category: '분류를 선택해 주세요.',
    alert_too_short_search_text: '검색어를 2자 이상 입력하세요.',
    alert_too_long_text: '글자를 초과 입력할 수 없습니다.',
    alert_too_short_text: '글자 이상을 입력해 주세요.',
    alert_already_liked: '이미 추천하였습니다',
    alert_delete_comment: '댓글을 삭제하시겠습니까?',
    alert_delete_reply: '덧글을 삭제하시겠습니까?',
    alert_empty_comment: '댓글을 작성해주세요',
    alert_empty_reply: '덧글을 작성해주세요',
    alert_login: '로그인 후 이용하실 수 있습니다.',
    alert_error: '일시적으로 장애가 발생했습니다.',
    alert_comment_login: '로그인 후 댓글을 입력하실 수 있습니다.',
    alert_comment_list_delete: '댓글을 삭제하시겠습니까?',
    alert_comment_reply_login: '로그인 후 덧글을 입력하실 수 있습니다.',
    alert_comment_reply_delete: '덧글을 삭제하시겠습니까?',
    alert_retry: '잠시 후에 다시 이용해 주십시요.',
    alert_realname_check: '본인확인을 하신 후에 게임을 이용하실 수 있습니다.',
    alert_delete_bookmark: '북마크를 해제하시겠습니까?',
    alert_level_check: '서비스 이용을 위해서는 9레벨 이상의 캐릭터가 존재해야 합니다.',
    alert_banned: '제재된 계정입니다. 자세한 사항은 고객센터로 문의바랍니다.',
    alert_not_exist_gameaccount: '서비스 이용을 위해 대표 캐릭터를 선택해주세요.',
    alert_allow_write_select_category: '\'전체\'분류 선택 시 글 작성이 불가능합니다 글 분류를 변경해주세요',

    // 북마크
    bookmark_have_done: '북마크한 글은 내 캐릭터 프로필 페이지에서 확인/해제할 수 있습니다.\n캐릭터 프로필 페이지로 이동하시겠습니까?',
    bookmark_already_have_done: '이미 북마크 되었습니다.',

    // 신고하기
    report_title: '신고하기',
    report_info: '게시물 신고는 하루에 20회까지 가능합니다.',
    report_remain: '남은 신고 횟수',
    report_number: '회',
    report_reporter: '신고자',
    report_date: '신고일시',
    report_username: '신고 대상자',
    report_reason_txt: '신고 사유',
    report_reason0: '기타',
    report_reason1: '음란성',
    report_reason2: '욕설',
    report_reason3: '일반광고',
    report_reason4: '현금거래',
    report_reason5: '불법프로그램',
    report_reason6: '도배',
    report_reason7: '개인정보',
    report_reason8: '저작권위반',
    report_reason9: '타인비방',
    report_select_reason: '신고 사유를 선택해 주세요.',
    report_error_again: '신고중에 오류가 발생했습니다. 다시 한번 시도해주세요.',
    report_reason: '신고 사유를 선택해 주세요.',
    report_have_done: '신고 처리 되었습니다.',
    report_already_have_done: '이미 신고하신 글입니다.',

    a_few_seconds_ago: '몇 초 전',
    seconds_ago: '초 전',
    a_minute_ago: '일 분 전',
    minutes_ago: '분 전',
    an_hour_ago: '한 시간 전',
    hours_ago: '시간 전',
    a_day_ago: '하루 전',
    days_ago: '일 전',
    a_month_ago: '1달 전',
    months_ago: '달 전',
    a_year_ago: '1년 전',
    years_ago: '년 전',
    movie_not_found_msg: '해당 영상을 찾을 수 없습니다.',
    WORLD_SELECTED_CHARACTER_NOTFOUND: '캐릭터를 선택해 주세요.',
    all: '전체',
    not_sevrer_master: '서버지기 캐릭터만 \'서버지기\' 글 작성이 가능합니다.',
    wrong_sevrer_master: '선택 서버를 확인해주세요.',
    wrong_sevrer_character: '선택 서버를 확인해주세요.',
  },
  en: {
    // Buttons
    btn_signup: 'Create an Account',
    btn_login: 'Log In',
    btn_logout: 'Log Out',
    btn_confirm: 'OK',
    btn_cancel: 'Cancel',
    btn_register: 'Submit',
    btn_close: 'Close',
    btn_write: 'Write',
    btn_modify: 'Edit',
    btn_delete: 'Delete',
    btn_bookmark_delete: 'del.',
    btn_list: 'List',
    btn_more: 'More',
    btn_refresh: 'Refresh',
    btn_prev: 'Previous',
    btn_next: 'Next',
    btn_declare: 'Report',
    btn_write_reply: 'Reply',
    btn_attach_emoticon: 'Emoticon',
    btn_attach_img: 'Image',
    btn_send: 'Send',
    btn_realname: 'Name Verification',
    btn_reporting: 'Report/Objection History',
    btn_fromlist: 'Go to List',
    btn_yes: 'Yes',
    btn_no: 'No',
    btn_search: 'Find',
    btn_reset: 'Reset',
    btn_finish: 'Complete',
    btn_orderby_desc: 'Newest',
    btn_orderby_good: 'Best',
    btn_orderby_asc: 'Oldest',

    // SNS
    kakao: 'KakaoTalk',
    kakaostory: 'KakaoStory',
    facebook: 'Facebook',
    twitter: 'Twitter',

    // Icons
    icon_attach: 'Image',
    icon_new: 'New Post',
    icon_type_list: 'List Type',
    icon_type_card: 'Card Type',
    icon_guide: 'Guide',

    // Words
    title: 'Title',
    notice: 'Notice',
    share: 'Share',
    recommend: 'Like',
    write: 'Write',
    search: 'Search',
    hit: 'View',
    comment: 'Comment',
    administrator: 'Administrator',
    level: 'Level',
    count: '',
    emoticon: 'Emoji',
    choose: '분류',

    // List
    list_msg_delete: 'This post is deleted.',
    list_none_article: 'No posts yet.',
    list_none_point: '',

    // Search form
    search_none: 'Nothing found. ',
    // 'Title + Content',
    search_searchtype_content: 'Entire Posts',
    search_searchtype_title: 'Title',
    search_searchtype_writer: 'Written by',
    search_result: 'Search Result',
    search_result_count: 'Results',
    search_result_return: 'Return',
    search_place_holder: 'Search',

    // View
    prev_article: 'Previous',
    next_article: 'Next',
    more_bookmark: 'Mark as Favorite',
    more_modify: 'Edit',
    more_delete: 'Delete',
    more_report: 'Report',
    signature_friend: 'Friends',
    signature_another_article: 'Post',

    // Comment
    comment_title: 'Comment',
    comment_placeholder_logout: 'Log in to write a comment.',
    comment_placeholder_login: 'You can enter up to 300 characters.',
    comment_placeholder_login_max: ( max = '300' ) => `You can enter up to ${ max } characters.`,
    comment_placeholder_image: 'Leave a comment. Select an image to upload immediately.',
    comment_placeholder_emoticon: 'Leave a comment. Select an image or sticker to upload immediately.',
    comment_list_delete: 'Deleted comment.',
    comment_reply_placeholder_logout: 'Log in to write a comment.',
    comment_reply_placeholder_login: 'Write your reply.',
    comment_reply_placeholder_image: 'Write a reply. Select an image to upload immediately.',
    comment_reply_placeholder_emoticon: 'Write a reply. Select an image or sticker to upload immediately.',
    comment_reply_list_delete: 'Deleted reply.',
    comment_placeholder_empty: 'Enter your first comment here!',
    comment_none_article: 'Enter your first comment here!',
    comment_chat_placeholder: '',
    comment_image_upload: '',

    // Write
    write_placeholder_title: 'Title',
    write_placeholder_textarea: 'Description',
    write_placeholder_contents: 'Description',
    write_attention: `Spamming the discussion board with posts,
     or posting material that is obscene, offensive, slanderous or embarrassing to any
     other person or entity is prohibited. In case of violation of our policies,
     you may be banned from writing posts or get further restrictions.`,

    // editor
    editor_font_face: 'Font',
    editor_font_size: 'Size',
    editor_font_color: 'Color',
    editor_bg_color: 'Background Color',
    editor_strong: 'Bold',
    editor_underline: 'Underline',
    editor_strike: 'Strikethrough',
    editor_justify_left: 'Left',
    editor_justify_center: 'Center',
    editor_justify_right: 'Right',
    editor_link: 'URL',
    editor_remove_link: 'Delete URL',
    editor_unordered_list: 'Bullets',
    editor_ordered_list: 'Numbers',
    editor_insert_image: 'Image',
    editor_insert_youtube: 'YouTube',
    editor_upload_movie: 'Video',

    // alert
    alert_valid_upload: '현재 진행 중인 작업이 있습니다.\n잠시만 기다려 주세요.',
    alert_delete_article: 'Delete?',
    alert_cancel_article: 'Cancel?',
    alert_empty_title: 'Please enter a title.',
    alert_too_short_title: 'Title should be at least 2 characters in length.',
    alert_too_long_title: 'Title cannot exceed 50 characters in length.',
    alert_empty_contents: 'Write something here.',
    alert_progressing: 'Processing request. Please wait a moment.',
    alert_empty_images: 'Upload an image.',
    alert_empty_category: 'Select a category.',
    alert_too_short_search_text: 'Search keyword should be at least 2 characters in length.',
    alert_too_long_text: 'Cannot exceed maximum word count.',
    alert_too_short_text: 'Please enter at least 2 characters.',
    alert_already_liked: 'Already recommended.',
    alert_delete_comment: 'Delete comment?',
    alert_delete_reply: 'Delete reply?',
    alert_empty_comment: 'Write a comment',
    alert_empty_reply: 'Write a reply',
    alert_login: 'Please log in to continue.',
    alert_error: 'A temporary error occurred.',
    alert_comment_login: 'Log in to write a comment.',
    alert_comment_list_delete: 'Delete comment?',
    alert_comment_reply_login: 'Log in to write a reply.',
    alert_comment_reply_delete: 'Delete reply?',
    alert_retry: 'Please try again later.',
    alert_realname_check: 'Please verify your account to play this game.',
    alert_delete_bookmark: 'Remove from favorite posts?',
    alert_level_check: '서비스 이용을 위해서는 9레벨 이상의 캐릭터가 존재해야 합니다.',
    alert_banned: '제재된 계정입니다. 자세한 사항은 고객센터로 문의바랍니다.',
    alert_not_exist_gameaccount: '서비스 이용을 위해 대표 캐릭터를 선택해주세요.',
    alert_allow_write_select_category: '\'전체\'분류 선택 시 글 작성이 불가능합니다 글 분류를 변경해주세요',

    // 북마크
    bookmark_have_done: 'You can view/undo bookmarks at your character\'s profile.\nGo to profile?',
    bookmark_already_have_done: 'Marked as favorite.',

    // 신고하기ƒ
    report_title: 'Report',
    report_info: 'You may submit a maximum of 20 reports a day.',
    report_remain: 'Remaining Reports',
    report_number: '',
    report_reporter: 'Reported by',
    report_date: 'Report Date',
    report_username: 'Player',
    report_reason_txt: 'Behavior',
    report_reason0: 'Notes',
    report_reason1: 'Pornography',
    report_reason2: 'Offensive Language',
    report_reason3: 'Inappropriate Advertising',
    report_reason4: 'Real Money Trading',
    report_reason5: 'Use of Illegal Program',
    report_reason6: 'Spamming',
    report_reason7: 'Breach of Personal Info',
    report_reason8: 'Copyright Infringement',
    report_reason9: 'Abusive Behavior',
    report_select_reason: 'Select an offense.',
    report_error_again: 'An error occurred while submitting the report. Please try again.',
    report_reason: 'Select an offense.',
    report_have_done: 'Report submitted.',
    report_already_have_done: 'Already reported.',

    a_few_seconds_ago: 'a few seconds ago',
    seconds_ago: 'seconds ago',

    a_minute_ago: 'a minute ago',
    minutes_ago: 'minutes ago',

    an_hour_ago: 'an hour ago',
    hours_ago: 'hours ago',

    a_day_ago: 'a day ago',
    days_ago: 'days ago',

    a_month_ago: 'a month ago',
    months_ago: 'months ago',

    a_year_ago: 'a year ago',
    years_ago: 'years ago',

    movie_not_found_msg: 'The video clip cannot be found.',
    WORLD_SELECTED_CHARACTER_NOTFOUND: '캐릭터를 선택해 주세요.',
    all: 'all',
    not_sevrer_master: 'Not a server master.',
    wrong_sevrer_master: 'Wrong a server master.',
    wrong_sevrer_character:  'Wrong a server master.',
  },
  ja: {
    // Buttons
    btn_signup: '会員登録',
    btn_login: 'ログイン',
    btn_logout: 'ログアウト',
    btn_confirm: '確認',
    btn_cancel: 'キャンセル',
    btn_register: '登録',
    btn_close: '閉じる',
    btn_write: '書き込み',
    btn_modify: '修正',
    btn_delete: '削除',
    btn_bookmark_delete: '解除',
    btn_list: 'リスト',
    btn_more: '詳細',
    btn_refresh: '更新',
    btn_prev: '戻る',
    btn_next: '進む',
    btn_declare: '通報',
    btn_write_reply: '返信',
    btn_attach_emoticon: '絵文字',
    btn_attach_img: '画像',
    btn_send: '送信',
    btn_realname: '本人認証',
    btn_reporting: '通報/異議履歴',
    btn_fromlist: 'リスト',
    btn_yes: 'はい',
    btn_no: 'いいえ',
    btn_search: '検索',
    btn_reset: '初期化',
    btn_finish: '完了',
    btn_orderby_desc: '日期順',
    btn_orderby_good: '回復順',
    btn_orderby_asc: '過去順',

    // SNS
    kakao: 'カカオトーク',
    kakaostory: 'カカオストーリー',
    facebook: 'Facebook',
    twitter: 'Twitter',

    // Icons
    icon_attach: '画像添付',
    icon_new: '新しい記事',
    icon_type_list: 'リスト タイプ',
    icon_type_card: 'カード タイプ',
    icon_guide: 'ガイド',

    // Words
    title: 'タイトル',
    notice: '告知',
    share: '共有する',
    recommend: 'いいね!',
    write: '書き込み',
    search: '検索',
    hit: '閲覧数',
    comment: 'コメント',
    administrator: '管理者',
    level: 'レベル',
    count: '個',
    emoticon: '絵文字',
    choose: '분류',

    // List
    list_msg_delete: '削除された記事です。',
    list_none_article: '登録された記事がありません。',
    list_none_point: 'ポイント記録がありません。',

    // Search form
    search_none: '検索結果が見つかりません。 ',
    search_searchtype_content: 'タイトル+内容',
    search_searchtype_title: 'タイトル',
    search_searchtype_writer: '作成者',
    search_result: '検索結果',
    search_result_count: '件',
    search_result_return: '戻る',
    search_place_holder: '検索',

    // View
    prev_article: `前へ`,
    next_article: '次へ',
    more_bookmark: 'お気に入り',
    more_modify: '修正',
    more_delete: '削除',
    more_report: '通報',
    signature_friend: '友達',
    signature_another_article: '作成記事',

    // Comment
    comment_title: 'コメント',
    comment_placeholder_logout: 'コメント入力にはログインが必要です。',
    comment_placeholder_login: 'コメントは300文字までです。',
    comment_placeholder_login_max: ( max = '300' ) => `コメントは${ max }文字までです。`,
    comment_placeholder_image: `コメント内容を入力してください。画像は選択すると送信されます`,
    comment_placeholder_emoticon: `コメント内容を入力してください。絵文字、画像は選択すると送信されます`,
    comment_list_delete: '削除されたコメントです。',
    comment_reply_placeholder_logout: '返信にはログインが必要です。',
    comment_reply_placeholder_login: '返信を入力してください。',
    comment_reply_placeholder_image: `返信内容を入力してください。画像は選択すると送信されます`,
    comment_reply_placeholder_emoticon: `返信内容を入力してください。絵文字、画像は選択すると送信されます`,
    comment_reply_list_delete: '削除された返信です。',
    comment_placeholder_empty: '最初のコメントを書いてみましょう。',
    comment_none_article: '最初のコメントを書いてみましょう。',
    comment_chat_placeholder: '血盟員たちとコミュニケーションしてみましょう。',
    comment_image_upload: 'アップロード中です。',

    // Write
    write_placeholder_title: 'タイトル',
    write_placeholder_textarea: '内容',
    write_placeholder_contents: '内容',
    write_attention: '誹謗中傷/虚偽事実の拡散/荒らし行為などの記事を書き込みされた場合、運営方針に従って書き込みの制限などの不利益を受ける場合があります。',

    // editor
    editor_font_face: 'フォント',
    editor_font_size: 'サイズ',
    editor_font_color: 'カラー',
    editor_bg_color: '塗りつぶし',
    editor_strong: '太字',
    editor_underline: '下線',
    editor_strike: '取り消し線',
    editor_justify_left: '左揃え',
    editor_justify_center: '中央揃え',
    editor_justify_right: '右揃え',
    editor_link: 'リンク',
    editor_remove_link: 'リンク削除',
    editor_unordered_list: '箇条書き',
    editor_ordered_list: '段落番号',
    editor_insert_image: '画像添付',
    editor_insert_youtube: 'Youtube添付',
    editor_upload_movie: '動画',

    // alert
    alert_valid_upload: '現在作業中の作業があります。\nしばらくお待ちください。',
    alert_delete_article: '削除しますか？',
    alert_cancel_article: '書き込みを取り消しますか？',
    alert_empty_title: 'タイトルを入力してください。 ',
    alert_too_short_title: 'タイトルは2文字以上で入力してください。',
    alert_too_long_title: 'タイトルは50文字以内で入力してください。  ',
    alert_empty_contents: '内容を入力してください。',
    alert_progressing: '要請中です。しばらくお待ちください。',
    alert_empty_images: '画像をアップロードしてください。',
    alert_empty_category: '分類を選択してください。',
    alert_too_short_search_text: '検索内容は2文字以上を入力してください。',
    alert_too_long_text: '文字数の上限を超えています。',
    alert_too_short_text: '入力されていません。',
    alert_already_liked: 'すでにいいね！をしています。',
    alert_delete_comment: 'コメントを削除しますか？',
    alert_delete_reply: '返信を削除しますか？',
    alert_empty_comment: 'コメントを入力してください。',
    alert_empty_reply: '返信を入力してください。',
    alert_login: 'ご利用にはログインが必要です。',
    alert_error: '一時的なエラーが発生しました。',
    alert_comment_login: 'コメント入力にはログインが必要です。',
    alert_comment_list_delete: 'コメントを削除しますか？',
    alert_comment_reply_login: '返信にはログインが必要です。',
    alert_comment_reply_delete: '返信を削除しますか？',
    alert_retry: 'しばらくしてから再度ご利用ください。',
    alert_realname_check: 'ゲームのご利用には本人確認が必要です。',
    alert_delete_bookmark: 'お気に入りを解除しますか？',
    alert_level_check: 'サービスのご利用にはレベル9以上のキャラクターが必要です。',
    alert_banned: 'ご利用が制限されたアカウントです。詳しくは公式サイトのサポートまでお問い合わせください。',
    alert_not_exist_gameaccount: '서비스 이용을 위해 대표 캐릭터를 선택해주세요.',
    alert_allow_write_select_category: '\'전체\'분류 선택 시 글 작성이 불가능합니다 글 분류를 변경해주세요',

    // お気に入り
    bookmark_have_done: 'ブックマークは自分のキャラクター プロフィール ページで確認/解除できます\nキャラクター プロフィールを確認しますか？',
    bookmark_already_have_done: `お気に入り登録されました。`,

    // 通報する
    report_title: '通報する',
    report_info: '記事の通報は1日20回まで可能です。',
    report_remain: '残り通報回数',
    report_number: '回',
    report_reporter: '通報者',
    report_date: '通報日時',
    report_username: '通報対象者',
    report_reason_txt: '通報理由',
    report_reason0: 'その他',
    report_reason1: 'わいせつ',
    report_reason2: 'ヘイト',
    report_reason3: '宣伝行為',
    report_reason4: '金銭取引',
    report_reason5: '違法プログラム',
    report_reason6: '荒らし',
    report_reason7: '個人情報',
    report_reason8: '著作権違反',
    report_reason9: '誹謗中傷',
    report_select_reason: '通報理由を選択してください。',
    report_error_again: '通報受付中にエラーが発生しました。もう一度実行してください。',
    report_reason: '通報理由を選択してください。',
    report_have_done: '通報を受け付けました。',
    report_already_have_done: 'すでに通報された記事です。',

    a_few_seconds_ago: '数秒前',
    seconds_ago: '秒前',
    a_minute_ago: '1分前',
    minutes_ago: '分前',
    an_hour_ago: '1時間前',
    hours_ago: '時間前',
    a_day_ago: '1日前',
    days_ago: '日前',
    a_month_ago: '1月前',
    months_ago: '月前',
    a_year_ago: '1年前',
    years_ago: '年前',

    movie_not_found_msg: '動画を見つけられませんでした。',
    WORLD_SELECTED_CHARACTER_NOTFOUND: 'キャラクターを選択してください。',
    all: 'all',
    not_sevrer_master: 'Not a server master.',
    wrong_sevrer_master: 'Wrong a server master.',
    wrong_sevrer_character:  'Wrong a server master.',
  },
  zh: {
    // Buttons
    btn_signup: '加入會員',
    btn_login: '登入',
    btn_logout: '登出',
    btn_confirm: '確認',
    btn_cancel: '取消',
    btn_register: '發布',
    btn_close: '關閉',
    btn_write: '撰寫',
    btn_modify: '修正',
    btn_delete: '刪除',
    btn_bookmark_delete: '解除',
    btn_list: '目錄',
    btn_more: '詳細查看',
    btn_refresh: '重新整理',
    btn_prev: '上一頁',
    btn_next: '下一頁',
    btn_declare: '檢舉',
    btn_write_reply: '回覆文章',
    btn_attach_emoticon: '加入表情符號',
    btn_attach_img: '加入圖片',
    btn_send: '傳送',
    btn_realname: '實名認證',
    btn_reporting: '檢舉/異議項目',
    btn_fromlist: '回到目錄',
    btn_yes: '是',
    btn_no: '否',
    btn_search: '查詢',
    btn_reset: '重置',
    btn_finish: '完成',
    btn_orderby_desc: '日期順',
    btn_orderby_good: '回復順',
    btn_orderby_asc: '過去順',

    // SNS
    kakao: 'KakaoTalk',
    kakaostory: 'KakaoStory',
    facebook: 'Facebook',
    twitter: 'Twitter',

    // Icons
    icon_attach: '加入圖片',
    icon_new: '新文章',
    icon_type_list: '清單類型',
    icon_type_card: '卡片類型',
    icon_guide: '介紹',

    // Words
    title: '標題',
    notice: '公告',
    share: '分享',
    recommend: '推薦',
    write: '撰寫',
    search: '搜尋',
    hit: '查詢',
    comment: '訊息',
    administrator: '管理者',
    level: '等級',
    count: '個',

    // List
    list_msg_delete: '該文章已刪除。',
    list_none_article: '沒有上傳的文章。',
    list_none_point: '',

    // Search form
    search_none: '沒有搜尋結果。',
    search_searchtype_content: '標題+內容',
    search_searchtype_title: '標題',
    search_searchtype_writer: '作者',
    search_result: '搜尋結果',
    search_result_count: '筆',
    search_result_return: '返回',
    search_place_holder: '討論串搜尋',

    // View
    prev_article: '前一篇',
    next_article: '後一篇',
    more_bookmark: '書籤',
    more_modify: '修正',
    more_delete: '刪除',
    more_report: '檢舉',
    signature_friend: '好友',
    signature_another_article: '文章',

    // Comment
    comment_title: '回覆',
    comment_placeholder_logout: '登入後即可輸入留言。',
    comment_placeholder_login: '可撰寫300字以內的留言。',
    comment_placeholder_login_max: ( max = '300' ) => `可撰寫${ max }字以內的留言。`,
    comment_placeholder_image: '請輸入訊息。選擇圖片時將立即進行發布。',
    comment_placeholder_emoticon: '請輸入訊息。選擇表情符號、圖片時將立即進行發布。',
    comment_list_delete: '該留言已刪除。',
    comment_reply_placeholder_logout: '登入後即可輸入留言。',
    comment_reply_placeholder_login: '請輸入回覆。',
    comment_reply_placeholder_image: '請輸入訊息。選擇圖片時將立即進行發布。',
    comment_reply_placeholder_emoticon: '請輸入訊息。選擇表情符號、圖片時將立即進行發布。',
    comment_reply_list_delete: '該回覆已刪除。',
    comment_placeholder_empty: '留下第一則留言。',
    comment_none_article: '留下第一則留言。',
    comment_chat_placeholder: '',
    comment_image_upload: '',

    // Write
    write_placeholder_title: '標題',
    write_placeholder_textarea: '內容',
    write_placeholder_contents: '內容',
    write_attention: '上傳辱罵、洗版、毀謗、散佈等違反經營政策的文章，可能會受到限制上傳文章等處分。',

    // editor
    editor_font_face: '字體',
    editor_font_size: '大小',
    editor_font_color: '文字顏色',
    editor_bg_color: '背景色',
    editor_strong: '粗體',
    editor_underline: '底線',
    editor_strike: '刪除線',
    editor_justify_left: '靠左對齊',
    editor_justify_center: '置中對齊',
    editor_justify_right: '靠右對齊',
    editor_link: '鏈接',
    editor_remove_link: '移除鏈接',
    editor_unordered_list: '項目符號',
    editor_ordered_list: '編號',
    editor_insert_image: '加入圖片',
    editor_insert_youtube: '插入YouTube',
    editor_upload_movie: '影片',

    // alert
    alert_valid_upload: '현재 진행 중인 작업이 있습니다.\n잠시만 기다려 주세요.',
    alert_delete_article: '確定刪除嗎？',
    alert_cancel_article: '確定取消撰寫文章嗎？',
    alert_empty_title: '請輸入標題。',
    alert_too_short_title: '請輸入2個字以上的標題。',
    alert_too_long_title: '請輸入50字以內的標題。',
    alert_empty_contents: '請輸入內容。',
    alert_progressing: '連結中，請稍後。',
    alert_empty_images: '請上傳圖片。',
    alert_empty_category: '請選擇分類。',
    alert_too_short_search_text: '請輸入2個字以上的搜尋字詞。',
    alert_too_long_text: '글字數超過無法輸入。',
    alert_too_short_text: '請輸入字以上。',
    alert_already_liked: '已推薦。',
    alert_delete_comment: '確定要刪除留言嗎？',
    alert_delete_reply: '確定要刪除回覆嗎？',
    alert_empty_comment: '請輸入留言',
    alert_empty_reply: '請輸入回覆',
    alert_login: '登入後即可使用',
    alert_error: '發生暫時性錯誤。',
    alert_comment_login: '登入後即可輸入留言。',
    alert_comment_list_delete: '確定要刪除留言嗎？',
    alert_comment_reply_login: '登入後即可輸入回覆。',
    alert_comment_reply_delete: '確定要刪除回覆嗎？',
    alert_retry: '請稍後再次使用。',
    alert_realname_check: '進行本人認證後即可開始遊戲。',
    alert_delete_bookmark: '要解除標記書籤嗎？',
    alert_level_check: '서비스 이용을 위해서는 9레벨 이상의 캐릭터가 존재해야 합니다.',
    alert_banned: '제재된 계정입니다. 자세한 사항은 고객센터로 문의바랍니다.',
    alert_not_exist_gameaccount: '서비스 이용을 위해 대표 캐릭터를 선택해주세요.',
    alert_allow_write_select_category: '\'전체\'분류 선택 시 글 작성이 불가능합니다 글 분류를 변경해주세요',

    // 북마크
    bookmark_have_done: '標記的文章可以於我的角色簡介頁面進行確認/解除。\n要移動至角色簡介頁面嗎？',
    bookmark_already_have_done: '設置書籤。',

    // 신고하기
    report_title: '檢舉',
    report_info: '每天可檢舉文章20次。',
    report_remain: '剩餘檢舉次數',
    report_number: '次',
    report_reporter: '檢舉人',
    report_date: '檢舉日期',
    report_username: '檢舉對象',
    report_reason_txt: '檢舉原因',
    report_reason0: '其他',
    report_reason1: '色情',
    report_reason2: '辱罵',
    report_reason3: '一般廣告',
    report_reason4: '現金交易',
    report_reason5: '非法軟體',
    report_reason6: '洗版',
    report_reason7: '個人資訊',
    report_reason8: '違反著作權',
    report_reason9: '毀謗他人',
    report_select_reason: '請選擇檢舉原因。',
    report_error_again: '檢舉時發生錯誤，請稍後再試。',
    report_reason: '請選擇檢舉原因。',
    report_have_done: '已檢舉完成。',
    report_already_have_done: '該文章已被檢舉。',

    a_few_seconds_ago: '剛才',
    seconds_ago: '秒前',
    a_minute_ago: '1分鐘前',
    minutes_ago: '分鐘前',
    an_hour_ago: '小時前',
    hours_ago: '小時前',
    a_day_ago: '1天前',
    days_ago: '天前',
    a_month_ago: '1個月前',
    months_ago: '個月前',
    a_year_ago: '1年前',
    years_ago: '年前',
    movie_not_found_msg: '無法找到該影片。',
    WORLD_SELECTED_CHARACTER_NOTFOUND: '캐릭터를 선택해 주세요.',
    all: 'all',
    not_sevrer_master: 'Not a server master.',
    wrong_sevrer_master: 'Wrong a server master.',
    wrong_sevrer_character:  'Wrong a server master.',
  },
};

export default Lang;
